const API_ROOT = '/oao';
const ASSETS_ROOT = '/oao/assets';
const AUTH_ROOT = '/oao/workflow/userauth';
const HOME_ROOT = '/oao/workflow/home';
const PAGES_ROOT = '/oao/pages';
const WORKFLOW_ROOT = '/oao/workflow';
const FIELDS_ROOT = '/oao/meta/fields';

export { API_ROOT, ASSETS_ROOT, AUTH_ROOT, HOME_ROOT, PAGES_ROOT, WORKFLOW_ROOT, FIELDS_ROOT };
